import { SCRIPT_FIELDS_MODEL_PATH } from '../../../interfaces/imetadata';
import { FieldPathUtils } from '../../../utils/fieldpath-utils';
import { SerializedFieldContext } from '../../content-control-to-field-map.service';
import { PasteLocation } from '../paste-location';
import { IPasteRule } from './ipasterule';

export class PasteScriptFieldInDocumentLocationRule implements IPasteRule {
  canPaste(pasteLocation: PasteLocation, pasteField: SerializedFieldContext): boolean {
    return FieldPathUtils.tailless(pasteField.path) === SCRIPT_FIELDS_MODEL_PATH; // is child of root entity?
  }
}
